import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferNoteComponent } from './offer-note.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [OfferNoteComponent],
  exports: [OfferNoteComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class OfferNoteModule { }
